import emptySliceApi from '../../../shared/store/emptyApiSlice';

interface SaveAccountWelcomeRequest {
  title: string;
  content: string;
  videoUrl: string;
  transcriptData: string;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    saveWelcomeContent: builder.mutation<
      void,
      { accountId: string; payload: SaveAccountWelcomeRequest }
    >({
      query: ({ accountId, payload }) => ({
        url: `v4/accounts/${accountId}/welcome`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['AccountData'],
    }),
  }),
});

export const { useSaveWelcomeContentMutation } = apiSlice;
